import { createStart, createMiddleware } from "@tanstack/react-start";

import { renderErrorPage } from "./lib/error-page";
// Intentionally NOT importing generated `attachSupabaseAuth` — replaced by
// `attachSupabaseAuthWithStaff` which also forwards the active staff id.
import { attachSupabaseAuthWithStaff } from "@/integrations/supabase/staff-auth-attacher";

// `@tanstack/react-start/server` is server-only: importing it at module scope
// can break this module in the client bundle, which would silently drop
// `functionMiddleware` (and therefore the Authorization header).
async function currentPathname(): Promise<string | null> {
  try {
    const { getRequest } = await import("@tanstack/react-start/server");
    return new URL(getRequest().url).pathname;
  } catch {
    return null;
  }
}

const errorMiddleware = createMiddleware().server(async ({ next }) => {
  try {
    return await next();
  } catch (error) {
    if (error != null && typeof error === "object" && "statusCode" in error) {
      throw error;
    }
    // Server-function errors must stay serialized RPC errors so the caller's
    // try/catch can handle them — never replace them with the HTML error page
    // (that renders as a blank screen in the client).
    const pathname = await currentPathname();
    if (pathname?.startsWith("/_serverFn") || pathname?.startsWith("/lovable/")) {
      throw error;
    }
    console.error(error);
    return new Response(renderErrorPage(), {
      status: 500,
      headers: { "content-type": "text/html; charset=utf-8" },
    });
  }
});



export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuthWithStaff],
  requestMiddleware: [errorMiddleware],
}));
